import { SortingState } from '@tanstack/react-table';

import { create } from '~/stores/create-store/createStore';

import { getDefaultInsightsFilterState, InsightsAnalysisType } from './utils';

export type InsightsFilterState = Record<InsightsAnalysisType, boolean>;

type AssetsTableStore = {
  sortingState: SortingState;
  insightsFilterState: InsightsFilterState;
  reset: () => void;
};

export const useAssetsTableStore = create<AssetsTableStore>(set => {
  const initialState = {
    sortingState: [],
    insightsFilterState: getDefaultInsightsFilterState(true),
  };
  return {
    ...initialState,
    reset: () => {
      set(initialState);
    },
  };
});
